"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.referencesCellRenderer = void 0;
var _react = _interopRequireDefault(require("react"));
var _accReferencePicker = require("@adsk/acc-reference-picker");
var _cellRenderers = require("./cellRenderers");
var _relationships = require("../../../constants/relationships");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const referencesCellRenderer = exports.referencesCellRenderer = (0, _cellRenderers.createSimpleCellRenderer)(_ref => {
  let {
    cellData,
    rowData
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_accReferencePicker.LinkedReferencesCell, {
    sourceEntityType: _relationships.ISSUES_ENTITY_TYPE,
    sourceEntityDomain: _relationships.ISSUES_DOMAIN,
    plugins: cellData.plugins,
    sourceEntityId: rowData.id
  });
});
//# sourceMappingURL=referencesCellRenderer.js.map